import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter, Route, Switch} from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
import BrandUtils from './utils/BrandUtils';
import DataFetcher from './utils/DataFetcher';
import Redirect from './modules/Redirect';
import Recharge from './modules/Recharge';
import User from './modules/User';
import Agent from './modules/Agent';
import WithdrawHistory from './modules/WithdrawHistory';
import About from './modules/About';
import Team from './modules/Team';
import TeamStatistic from './modules/TeamStatistic';
import AgentDelegate from './modules/AgentDelegate';
import Delegate from './modules/Delegate';
import GoldPlan from './modules/GoldPlan';
import AgentBill from './modules/AgentBill';
import DebugPay from './modules/DebugPay';
import AgentMore from './modules/AgentMore';
import AgentCoupon from './modules/AgentCoupon';
import AgentCouponCodes from './modules/AgentCouponCodes';
import AgentCouponOrganization from './modules/AgentCouponOrganization';
import AgentCouponOperator from './modules/AgentCouponOperator';
import AgentCouponGrabbed from './modules/AgentCouponGrabbed';
import UserCoupon from './modules/UserCoupon';
import UserCouponUsage from './modules/UserCouponUsage';
import UserCouponResult from './modules/UserCouponResult';
import UserCouponPacket from './modules/UserCouponPacket';
import UserCouponActivity from './modules/UserCouponActivity';
import UserCouponTicket from './modules/UserCouponTicket';
import OperatorCoupon from './modules/OperatorCoupon';
import OperatorCouponGrabbed from './modules/OperatorCouponGrabbed';
import OperatorCouponTicket from './modules/OperatorCouponTicket';
import GameRank from './modules/GameRank';
import PacketOfAgent from './modules/PacketOfAgent';
import PacketOfDelegate from './modules/PacketOfDelegate';
import DeviceOfAgent from './modules/DeviceOfAgent';
import DeviceOfDelegate from './modules/DeviceOfDelegate';
import SiteOfAgent from './modules/SiteOfAgent';
import SiteOfDelegate from './modules/SiteOfDelegate';
import DeviceRevenueOfAgent from './modules/DeviceRevenueOfAgent';
import DeviceRevenueOfDelegate from './modules/DeviceRevenueOfDelegate';
import DeviceLogOfAgent from './modules/DeviceLogOfAgent';
import DeviceLogOfDelegate from './modules/DeviceLogOfDelegate';
import AgentGame from './modules/AgentGame';
import Kf from './modules/Kf';
import './styles/index.css';
import './styles/iconfont.css';

ReactDOM.render(
  (
    <HashRouter>
      <Switch>
        <Route exact path="/" component={GoldPlan}/>
        <Route path="/redirect" component={Redirect}/>
        <Route path="/recharge" component={Recharge}/>
        <Route exact path="/user" component={User}/>
        <Route exact path="/agent" component={Agent}/>
        <Route exact path="/device" component={DeviceOfAgent}/>
        <Route exact path="/site" component={SiteOfAgent}/>
        <Route exact path="/packet" component={PacketOfAgent}/>
        <Route path="/device_log/:deviceId" component={DeviceLogOfAgent}/>
        <Route exact path="/withdraw" component={WithdrawHistory}/>
        <Route exact path="/about" component={About}/>
        <Route exact path="/team" component={Team}/>
        <Route path="/team/statistic/:agentId" component={TeamStatistic}/>
        <Route exact path="/agent/bill" component={AgentBill}/>
        <Route exact path="/agent/delegate" component={AgentDelegate}/>
        <Route path="/delegate/home/:delegateId" component={Delegate}/>
        <Route path="/delegate/device/:delegateId" component={DeviceOfDelegate}/>
        <Route path="/delegate/device_log/:deviceId" component={DeviceLogOfDelegate}/>
        <Route path="/delegate/packet/:delegateId" component={PacketOfDelegate}/>
        <Route path="/delegate/site/:delegateId" component={SiteOfDelegate}/>
        <Route path="/delegate/:delegateId/device_revenue/:siteId" component={DeviceRevenueOfDelegate}/>
        <Route path="/debug_pay" component={DebugPay}/>
        <Route path="/agent/more" component={AgentMore}/>
        <Route path="/agent/coupon" component={AgentCoupon}/>
        <Route path="/agent/coupon_codes/:activityId" component={AgentCouponCodes}/>
        <Route path="/agent/coupon_organization" component={AgentCouponOrganization}/>
        <Route path="/agent/coupon_operator/:organizationId" component={AgentCouponOperator}/>
        <Route path="/agent/coupon_grabbed" component={AgentCouponGrabbed}/>
        <Route path="/agent/device_revenue/:siteId" component={DeviceRevenueOfAgent}/>
        <Route path="/user/coupon" component={UserCoupon}/>
        <Route path="/user/coupon_usage" component={UserCouponUsage}/>
        <Route path="/user/coupon_result" component={UserCouponResult}/>
        <Route path="/user/coupon_packet" component={UserCouponPacket}/>
        <Route path="/user/coupon_activity" component={UserCouponActivity}/>
        <Route path="/user/coupon_ticket" component={UserCouponTicket}/>
        <Route path="/operator/coupon" component={OperatorCoupon}/>
        <Route path="/operator/coupon_grabbed" component={OperatorCouponGrabbed}/>
        <Route path="/operator/coupon_ticket" component={OperatorCouponTicket}/>
        <Route path="/rank/game" component={GameRank}/>
        <Route path="/kf" component={Kf}/>
        <Route path="/agent/game" component={AgentGame}/>
      </Switch>
    </HashRouter>
  ),
  document.getElementById('root'),
  () => {
    DataFetcher.jsapiAuth((resp) => {
      if(window.wx) {
        window.wx.config({
          debug: false,
          appId: resp.data.appId,
          timestamp: resp.data.timestamp,
          nonceStr: resp.data.nonceStr,
          signature: resp.data.signature,
          jsApiList: ['openAddress', 'chooseWXPay', 'updateTimelineShareData', 'updateAppMessageShareData']
        })
      }
    })
    BrandUtils.initPageBrand()
  }
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js